// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRoleUpdateDto
 */
export interface IRoleUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IRoleUpdateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IRoleUpdateDto
     */
    description?: string;
    /**
     * 
     * @type {Set<number>}
     * @memberof IRoleUpdateDto
     */
    granted_permission_ids?: Set<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IRoleUpdateDto
     */
    role_ids_allowed_for_creation?: Set<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IRoleUpdateDto
     */
    allowed_for_creation_by_role_ids?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof IRoleUpdateDto
     */
    org_properties_state_config_id: number;
}

/**
 * Check if a given object implements the IRoleUpdateDto interface.
 */
export function instanceOfIRoleUpdateDto(value: object): value is IRoleUpdateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('org_properties_state_config_id' in value) || value['org_properties_state_config_id'] === undefined) return false;
    return true;
}

export function IRoleUpdateDtoFromJSON(json: any): IRoleUpdateDto {
    return IRoleUpdateDtoFromJSONTyped(json, false);
}

export function IRoleUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRoleUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'granted_permission_ids': json['granted_permission_ids'] == null ? undefined : new Set(json['granted_permission_ids']),
        'role_ids_allowed_for_creation': json['role_ids_allowed_for_creation'] == null ? undefined : new Set(json['role_ids_allowed_for_creation']),
        'allowed_for_creation_by_role_ids': json['allowed_for_creation_by_role_ids'] == null ? undefined : new Set(json['allowed_for_creation_by_role_ids']),
        'org_properties_state_config_id': json['org_properties_state_config_id'],
    };
}

export function IRoleUpdateDtoToJSON(json: any): IRoleUpdateDto {
    return IRoleUpdateDtoToJSONTyped(json, false);
}

export function IRoleUpdateDtoToJSONTyped(value?: IRoleUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'granted_permission_ids': value['granted_permission_ids'] == null ? undefined : Array.from(value['granted_permission_ids'] as Set<any>),
        'role_ids_allowed_for_creation': value['role_ids_allowed_for_creation'] == null ? undefined : Array.from(value['role_ids_allowed_for_creation'] as Set<any>),
        'allowed_for_creation_by_role_ids': value['allowed_for_creation_by_role_ids'] == null ? undefined : Array.from(value['allowed_for_creation_by_role_ids'] as Set<any>),
        'org_properties_state_config_id': value['org_properties_state_config_id'],
    };
}

